import React, { useState, useEffect, useCallback } from "react";
import MainContainer from "../../components/MainContainer";
import { userDetailContext } from "../../App";
import { headerContract } from "../../data/modules/contract_header";
import { useContext } from "react";
import { useNavigate } from 'react-router-dom';
import {
    Grid,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Button,
    IconButton,
    Chip,
    Typography,
    TextField,
    CircularProgress,
    Tooltip,
    Card,
    TablePagination,
    InputAdornment,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Box,
    Backdrop,
    Tabs,
    Tab
} from "@material-ui/core";
import { Alert } from "@mui/material";
import { makeStyles } from "@material-ui/core/styles";
import VisibilityIcon from '@material-ui/icons/Visibility';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import CancelIcon from '@material-ui/icons/Cancel';
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
import DescriptionIcon from '@material-ui/icons/Description';
import SearchIcon from '@material-ui/icons/Search';
import RefreshIcon from '@material-ui/icons/Refresh';
import WarningIcon from '@material-ui/icons/Warning';
import FilterListIcon from '@material-ui/icons/FilterList';
import ClearIcon from '@material-ui/icons/Clear';
import HistoryIcon from '@material-ui/icons/History';
import AddIcon from '@material-ui/icons/Add';
import LockIcon from '@material-ui/icons/Lock';
import UserService from "../../services/UserService";
import ConsultationHistory from "./ConsultationHistory";
import DirectionService from "../../services/DirectionService";
import PlanningService from "../../services/PlanningService";
import ContractService from "../../services/ContractService";
import PasswordDialog from "./PasswordDialog";

const useStyles = makeStyles((theme) => ({
    container: {
        padding: theme.spacing(3),
    },
    tableContainer: {
        marginTop: theme.spacing(2),
        borderRadius: '12px',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
        position: 'relative',
        zIndex: 1,
    },
    table: {
        minWidth: 650,
    },
    statusChip: {
        fontWeight: 'bold',
    },
    statusComplete: {
        backgroundColor: '#4caf50',
        color: 'white',
    },
    statusMissing: {
        backgroundColor: '#f44336',
        color: 'white',
    },
    statusPartial: {
        backgroundColor: '#ff9800',
        color: 'white',
    },
    statusActive: {
        backgroundColor: '#2196f3',
        color: 'white',
    },
    statusExpired: {
        backgroundColor: '#9e9e9e',
        color: 'white',
    },
    statsCard: {
        padding: theme.spacing(2),
        textAlign: 'center',
        cursor: 'pointer',
        transition: 'transform 0.2s',
        '&:hover': {
            transform: 'translateY(-5px)',
            boxShadow: theme.shadows[4],
        },
    },
    statsNumber: {
        fontSize: '2rem',
        fontWeight: 'bold',
        color: theme.palette.primary.main,
    },
    statsLabel: {
        color: theme.palette.text.secondary,
        marginTop: theme.spacing(1),
    },
    filterContainer: {
        marginBottom: theme.spacing(3),
        padding: theme.spacing(2),
        backgroundColor: '#f5f5f5',
        borderRadius: '8px',
    },
    filterTitle: {
        marginBottom: theme.spacing(2),
        fontWeight: 'bold',
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(1),
    },
    activeFilters: {
        marginTop: theme.spacing(2),
        display: 'flex',
        gap: theme.spacing(1),
        flexWrap: 'wrap',
    },
    activeFilterChip: {
        backgroundColor: theme.palette.primary.light,
        color: 'white',
        '&:hover': {
            backgroundColor: theme.palette.primary.main,
        },
    },
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff',
    },
    tabs: {
        marginBottom: theme.spacing(2),
        backgroundColor: 'white',
        borderRadius: '8px',
    },
    accessDenied: {
        textAlign: 'center',
        padding: theme.spacing(8),
    },
    loadingContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '400px',
    },
}));

export default function ContractPersonnalList(props) {
    const classes = useStyles();
    const navigate = useNavigate();
    
    // États
    const [personnel, setPersonnel] = useState([]);
    const [filteredPersonnel, setFilteredPersonnel] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [direction, setDirection] = useState([]);
    const [iddir, setIddir] = useState(0);
    const [service, setService] = useState([]);
    
    // État pour l'accès sécurisé à la liste
    const [passwordDialogOpen, setPasswordDialogOpen] = useState(false);
    const [isAccessGranted, setIsAccessGranted] = useState(false);
    const [accessChecking, setAccessChecking] = useState(true);
    
    // États pour l'historique
    const [historyDialogOpen, setHistoryDialogOpen] = useState(false);
    const [selectedPersonnelForHistory, setSelectedPersonnelForHistory] = useState(null);
    
    // États pour les filtres
    const [searchNom, setSearchNom] = useState('');
    const [searchMatricule, setSearchMatricule] = useState('');
    const [contractStatusFilter, setContractStatusFilter] = useState('all');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [activeTab, setActiveTab] = useState(0);
    const [stats, setStats] = useState({
        total: 0,
        withContract: 0,
        withoutContract: 0,
        activeContracts: 0,
        expiredContracts: 0
    });
    const [refreshKey, setRefreshKey] = useState(0); 
    const iddiruser = localStorage.getItem("USER_DIR");
    const [form, setForm] = useState({
        direction_id: parseInt(localStorage.getItem("USER_DIR")) || 0,
        service_id: 0,
        type: "all"
    });

    // États pour les filtres de recherche
    const [searchFilters, setSearchFilters] = useState({
        nom: '',
        matricule: '',
        direction_id: parseInt(localStorage.getItem("USER_DIR")) || 0,
        service_id: 0
    });

    // Vérifier si la session est encore valide
    const isSessionValid = () => {
        const token = sessionStorage.getItem('personnel_access_token');
        const expiry = sessionStorage.getItem('personnel_access_expiry');
        
        if (!token || !expiry) {
            return false;
        }
        
        const now = Date.now();
        const expiryTime = parseInt(expiry);
        
        if (now >= expiryTime) {
            sessionStorage.removeItem('personnel_access_token');
            sessionStorage.removeItem('personnel_access_expiry');
            return false;
        }
        
        return true;
    };

    // Vérifier et gérer l'accès à la liste
    useEffect(() => {
        const checkAccess = () => {
            if (isSessionValid()) {
                setIsAccessGranted(true);
                setAccessChecking(false);
                loadPersonnel();
            } else {
                setIsAccessGranted(false);
                setAccessChecking(false);
                setPasswordDialogOpen(true);
            }
        };
        
        checkAccess();
    }, []);

    function handleChangeService(ev) {
        const { name, value } = ev.target;
        setForm({ ...form, [name]: value });
    }

    // Charger la liste du personnel
    const loadPersonnel = useCallback(async () => {
        if (!isAccessGranted) return;
        
        setLoading(true);
        setError(null);
        try {
            const result = await ContractService.listusers(
                searchFilters.direction_id, 
                searchFilters.service_id, 
                searchFilters.matricule,
                searchFilters.nom
            );
            if (result && result.data) {
                setPersonnel(result.data);
                setFilteredPersonnel(result.data);
                updateStats(result.data);
            } else {
                setError("Erreur lors du chargement des données");
            }
        } catch (err) {
            if (err.response?.status === 401 || err.message?.includes('session')) {
                handleSessionExpired();
            } else {
                setError("Impossible de charger la liste du personnel");
            }
        } finally {
            setLoading(false);
        }
    }, [searchFilters, isAccessGranted]);

    // Gérer l'expiration de session
    const handleSessionExpired = () => {
        sessionStorage.removeItem('personnel_access_token');
        sessionStorage.removeItem('personnel_access_expiry');
        setIsAccessGranted(false);
        setPasswordDialogOpen(true);
    };

    // Charger les directions
    useEffect(() => {
        const dirId = parseInt(localStorage.getItem("USER_DIR")) || 0;
        setIddir(dirId);
        setForm(prev => ({ ...prev, direction_id: dirId }));
        setSearchFilters(prev => ({ ...prev, direction_id: dirId }));
        
        DirectionService.getDirection().then((res) => {
            if (res && res.status) {
                setDirection(res.data);
            }
        });
    }, []);

    // Charger les services
    useEffect(() => {
        if (iddir !== 0 && iddir !== "") {
            PlanningService.Direction(iddir).then((results) => {
                if (results && results.data) {
                    setService(results.data);
                }
            });
        } else {
            setService([]);
        }
    }, [iddir]);

    // Charger le personnel quand l'accès est accordé
    useEffect(() => {
        if (isAccessGranted) {
            loadPersonnel();
        }
    }, [loadPersonnel, isAccessGranted, refreshKey]);

    // Mettre à jour les statistiques
    const updateStats = (data) => {
        const total = data.length;
        const withContract = data.filter(p => p.has_contract === 1 || p.contract_file).length;
        const withoutContract = total - withContract;
        const activeContracts = data.filter(p => p.contract_status === 'active').length;
        const expiredContracts = data.filter(p => p.contract_status === 'expired').length;
        
        setStats({ total, withContract, withoutContract, activeContracts, expiredContracts });
    };

    // Vérifier si le contrat est actif
    const isContractActive = (person) => {
        if (!person.contract_end_date) return true;
        const endDate = new Date(person.contract_end_date);
        const today = new Date();
        return endDate >= today;
    };

    // Appliquer les filtres
    const applyFilters = () => {
        let filtered = [...personnel];
        
        if (contractStatusFilter !== 'all') {
            filtered = filtered.filter(person => {
                const hasContract = person.has_contract === 1 || person.contract_file;
                if (contractStatusFilter === 'active') {
                    return hasContract && isContractActive(person);
                } else if (contractStatusFilter === 'expired') {
                    return hasContract && !isContractActive(person);
                } else if (contractStatusFilter === 'with_contract') {
                    return hasContract;
                } else if (contractStatusFilter === 'without_contract') {
                    return !hasContract;
                }
                return true;
            });
        }
        
        setFilteredPersonnel(filtered);
        setPage(0);
    };

    useEffect(() => {
        if (isAccessGranted) {
            applyFilters();
        }
    }, [contractStatusFilter, personnel, isAccessGranted]);

    // Recherche
    const handleSearch = () => {
        setSearchFilters({
            nom: searchNom,
            matricule: searchMatricule,
            direction_id: form.direction_id,
            service_id: form.service_id
        });
        setPage(0);
    };

    // Réinitialiser les filtres
    const handleResetFilters = () => {
        const defaultDirId = parseInt(localStorage.getItem("USER_DIR")) || 0;
        
        setSearchNom('');
        setSearchMatricule('');
        setContractStatusFilter('all');
        setForm({
            direction_id: defaultDirId,
            service_id: 0,
            type: "all"
        });
        setSearchFilters({
            nom: '',
            matricule: '',
            direction_id: defaultDirId,
            service_id: 0
        });
        setIddir(defaultDirId);
        setActiveTab(0);
        setPage(0);
    };

    // Ouvrir directement le contrat sans authentification
    const handleOpenContractDialog = (person) => {
        // Redirection directe vers la page du contrat
        if (person && person.user_id) {
            navigate(`/contract_user/${person.user_id}`);
        }
    };

    const handleViewHistory = (person) => {
        setSelectedPersonnelForHistory(person);
        setHistoryDialogOpen(true);
    };

    const handleCloseHistoryDialog = () => {
        setHistoryDialogOpen(false);
        setSelectedPersonnelForHistory(null);
    };

    const getContractStatus = (person) => {
        const hasContract = person.has_contract === 1 || person.contract_file;
        
        if (!hasContract) {
            return { label: 'Sans contrat', color: 'statusMissing', icon: <CancelIcon /> };
        }
        
        const active = isContractActive(person);
        if (active) {
            return { label: 'Contrat actif', color: 'statusActive', icon: <CheckCircleIcon /> };
        } else {
            return { label: 'Contrat expiré', color: 'statusExpired', icon: <WarningIcon /> };
        }
    };

    function handleChangeDirection(event) {
        const { name, value } = event.target;
        const newValue = parseInt(value) || 0;
        setForm({ ...form, [name]: newValue });
        setIddir(newValue);
    }

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleTabChange = (event, newValue) => {
        setActiveTab(newValue);
        switch(newValue) {
            case 0:
                setContractStatusFilter('all');
                break;
            case 1:
                setContractStatusFilter('active');
                break;
            case 2:
                setContractStatusFilter('expired');
                break;
            case 3:
                setContractStatusFilter('without_contract');
                break;
            default:
                break;
        }
    };

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            handleSearch();
        }
    };

    const handleRefresh = () => {
        if (!isSessionValid()) {
            handleSessionExpired();
            return;
        }
        loadPersonnel();
    };

    // Accès à la liste accordé
    const handleListAccessGranted = () => {
        setIsAccessGranted(true);
    };

    // Déconnexion
    const handleLogout = () => {
        sessionStorage.removeItem('personnel_access_token');
        sessionStorage.removeItem('personnel_access_expiry');
        setIsAccessGranted(false);
        setPasswordDialogOpen(true);
    };

    if (accessChecking) {
        return (
            <MainContainer {...headerContract}>
                <div className={classes.loadingContainer}>
                    <CircularProgress size={60} />
                </div>
            </MainContainer>
        );
    }

    if (!isAccessGranted) {
        return (
            <MainContainer {...headerContract}>
                <div className={classes.accessDenied}>
                    <LockIcon style={{ fontSize: 80, color: '#ccc', marginBottom: 20 }} />
                    <Typography variant="h5" color="textSecondary" gutterBottom>
                        Accès sécurisé requis
                    </Typography>
                    <Typography variant="body2" color="textSecondary" gutterBottom>
                        Veuillez vous authentifier pour accéder à cette page
                    </Typography>
                </div>
                
                <PasswordDialog
                    open={passwordDialogOpen}
                    onClose={() => navigate('/home')}
                    onSuccess={handleListAccessGranted}
                    title="Accès à la gestion des contrats du personnel"
                    typecontrat="Personnel"
                    lienapresvalidate="/contract_user"
                />
            </MainContainer>
        );
    }

    return (
        <MainContainer {...headerContract}>
            <div className={classes.container}>
                <Backdrop className={classes.backdrop} open={loading}>
                    <CircularProgress color="inherit" />
                </Backdrop>

                {/* Statistiques */}
                <Grid container spacing={3}>
                    <Grid item xs={12} sm={6} md={3}>
                        <Card className={classes.statsCard} onClick={() => handleTabChange(null, 0)}>
                            <Typography className={classes.statsNumber}>{stats.total}</Typography>
                            <Typography className={classes.statsLabel}>Total Personnel</Typography>
                        </Card>
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                        <Card className={classes.statsCard} style={{ borderTop: '4px solid #4caf50' }} onClick={() => handleTabChange(null, 1)}>
                            <Typography className={classes.statsNumber} style={{ color: '#4caf50' }}>{stats.activeContracts}</Typography>
                            <Typography className={classes.statsLabel}>Contrats Actifs</Typography>
                        </Card>
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                        <Card className={classes.statsCard} style={{ borderTop: '4px solid #ff9800' }} onClick={() => handleTabChange(null, 2)}>
                            <Typography className={classes.statsNumber} style={{ color: '#ff9800' }}>{stats.expiredContracts}</Typography>
                            <Typography className={classes.statsLabel}>Contrats Expirés</Typography>
                        </Card>
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                        <Card className={classes.statsCard} style={{ borderTop: '4px solid #f44336' }} onClick={() => handleTabChange(null, 3)}>
                            <Typography className={classes.statsNumber} style={{ color: '#f44336' }}>{stats.withoutContract}</Typography>
                            <Typography className={classes.statsLabel}>Sans Contrat</Typography>
                        </Card>
                    </Grid>
                </Grid>

                {/* Barre d'info session */}
                <Box display="flex" justifyContent="flex-end" mb={1}>
                    <Tooltip title="Déconnexion sécurisée">
                        <Button size="small" color="secondary" onClick={handleLogout}>
                            <LockIcon style={{ fontSize: 16, marginRight: 4 }} />
                            Quitter l'accès sécurisé
                        </Button>
                    </Tooltip>
                </Box>

                {/* Onglets */}
                <Paper className={classes.tabs}>
                    <Tabs value={activeTab} onChange={handleTabChange} indicatorColor="primary" textColor="primary" variant="fullWidth">
                        <Tab label="Tous" />
                        <Tab label="Contrats Actifs" />
                        <Tab label="Contrats Expirés" />
                        <Tab label="Sans Contrat" />
                    </Tabs>
                </Paper>

                {/* Panneau de filtres */}
                <Paper className={classes.filterContainer}>
                    <div className={classes.filterTitle}>
                        <FilterListIcon color="primary" />
                        <Typography variant="h6">Filtres de recherche</Typography>
                    </div>
                    
                    <Grid container spacing={3}>
                        <Grid item xs={12} md={2}>
                            <Button fullWidth variant="contained" color="primary" onClick={handleSearch} startIcon={<SearchIcon />} style={{ height: '56px' }}>
                                Filtrer
                            </Button>
                        </Grid>
                        <Grid item xs={12} md={2}>
                            <Button fullWidth variant="outlined" color="primary" onClick={handleResetFilters} startIcon={<ClearIcon />} style={{ height: '56px' }}>
                                Réinitialiser
                            </Button>
                        </Grid>
                        <Grid item xs={12} md={2}>
                            <Button fullWidth variant="outlined" color="default" onClick={handleRefresh} startIcon={<RefreshIcon />} style={{ height: '56px' }}>
                                Rafraîchir
                            </Button>
                        </Grid>

                        <Grid item xs={12} md={6} />

                        <Grid item xs={12} md={3}>
                            <FormControl fullWidth variant="outlined" size="small">
                                <InputLabel>Direction</InputLabel>
                                <Select
                                    label="Direction"
                                    value={form.direction_id}
                                    name="direction_id"
                                    onChange={handleChangeDirection}
                                    disabled={parseInt(iddiruser, 10) !== 1} 
                                >
                                    <MenuItem value={0}>Toutes</MenuItem>
                                    {direction.map((row) => (
                                        <MenuItem key={row.direction_id} value={row.direction_id}>
                                            {row.code}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                        
                        <Grid item xs={12} md={3}>
                            <FormControl fullWidth variant="outlined" size="small">
                                <InputLabel>Service</InputLabel>
                                <Select 
                                    label="Service" 
                                    value={form.service_id} 
                                    name="service_id" 
                                    onChange={handleChangeService}
                                >
                                    <MenuItem value={0}>Tous</MenuItem>
                                    {service.map((row) => (
                                        <MenuItem key={row.service_id} value={row.service_id}>
                                            {row.code}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                  
                        <Grid item xs={12} md={3}>
                            <TextField
                                fullWidth
                                variant="outlined"
                                placeholder="Rechercher par nom ou prénom..."
                                label="Nom / Prénom"
                                value={searchNom}
                                onChange={(e) => setSearchNom(e.target.value)}
                                onKeyPress={handleKeyPress}
                                size="small"
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <SearchIcon />
                                        </InputAdornment>
                                    ),
                                    endAdornment: searchNom && (
                                        <InputAdornment position="end">
                                            <IconButton size="small" onClick={() => setSearchNom('')}>
                                                <ClearIcon />
                                            </IconButton>
                                        </InputAdornment>
                                    )
                                }}
                            />
                        </Grid>
                        
                        <Grid item xs={12} md={3}>
                            <TextField
                                fullWidth
                                variant="outlined"
                                placeholder="Rechercher par matricule..."
                                label="Matricule"
                                value={searchMatricule}
                                onChange={(e) => setSearchMatricule(e.target.value)}
                                onKeyPress={handleKeyPress}
                                size="small"
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <SearchIcon />
                                        </InputAdornment>
                                    ),
                                    endAdornment: searchMatricule && (
                                        <InputAdornment position="end">
                                            <IconButton size="small" onClick={() => setSearchMatricule('')}>
                                                <ClearIcon />
                                            </IconButton>
                                        </InputAdornment>
                                    )
                                }}
                            />
                        </Grid>
                    </Grid>
                </Paper>

                {/* Résultats */}
                <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                    <Typography variant="body2" color="textSecondary">
                        {filteredPersonnel.length} résultat(s) trouvé(s) sur {personnel.length} personnes
                    </Typography>
                </Box>

                {/* Tableau du personnel */}
                <TableContainer component={Paper} className={classes.tableContainer}>
                    {error ? (
                        <Alert severity="error" style={{ margin: '20px' }}>{error}</Alert>
                    ) : filteredPersonnel.length === 0 && !loading ? (
                        <div style={{ textAlign: 'center', padding: '50px' }}>
                            <Typography variant="h6" color="textSecondary">Aucun personnel trouvé</Typography>
                            <Button variant="outlined" color="primary" onClick={handleResetFilters} style={{ marginTop: '20px' }}>
                                Réinitialiser les filtres
                            </Button>
                        </div>
                    ) : (
                        <>
                            <Table className={classes.table}>
                                <TableHead>
                                    <TableRow style={{ backgroundColor: '#1976d2' }}>
                                        <TableCell style={{ color: 'white', fontWeight: 'bold' }}>N°</TableCell>
                                        <TableCell style={{ color: 'white', fontWeight: 'bold' }}>Matricule</TableCell>
                                        <TableCell style={{ color: 'white', fontWeight: 'bold' }}>Nom & Prénom</TableCell>
                                        <TableCell style={{ color: 'white', fontWeight: 'bold' }}>Direction</TableCell>
                                        <TableCell style={{ color: 'white', fontWeight: 'bold' }}>Service</TableCell>
                                        <TableCell style={{ color: 'white', fontWeight: 'bold' }}>Email</TableCell>
                                        <TableCell style={{ color: 'white', fontWeight: 'bold' }}>Téléphone</TableCell>
                                        <TableCell style={{ color: 'white', fontWeight: 'bold' }}>Statut</TableCell>
                                        <TableCell style={{ color: 'white', fontWeight: 'bold' }}>Actions</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {filteredPersonnel
                                        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                        .map((person, index) => {
                                            const contractStatus = getContractStatus(person);
                                            return (
                                                <TableRow key={person.user_id || person.person_id} hover>
                                                    <TableCell>{page * rowsPerPage + index + 1}</TableCell>
                                                    <TableCell>{person.registration_number || '-'}</TableCell>
                                                    <TableCell>
                                                        <strong>{person.full_name || `${person.first_name || ''} ${person.last_name || ''}`}</strong>
                                                    </TableCell>
                                                    <TableCell>{person.direction || '-'}</TableCell>
                                                    <TableCell>{person.service || '-'}</TableCell>
                                                    <TableCell>{person.email || '-'}</TableCell>
                                                    <TableCell>{person.telephone || '-'}</TableCell>
                                                    <TableCell>
                                                        <Chip
                                                            icon={contractStatus.icon}
                                                            label={contractStatus.label}
                                                            className={`${classes.statusChip} ${classes[contractStatus.color]}`}
                                                            size="small"
                                                        />
                                                    </TableCell>
                                                    <TableCell>
                                                        <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                                                            <Tooltip title="Voir contrat">
                                                                <Button
                                                                    variant="outlined"
                                                                    color="primary"
                                                                    size="small"
                                                                    startIcon={<DescriptionIcon />}
                                                                    onClick={() => handleOpenContractDialog(person)}
                                                                >
                                                                    Contrat
                                                                </Button>
                                                            </Tooltip>
                                                            <Tooltip title="Voir historique">
                                                                <Button
                                                                    variant="outlined"
                                                                    size="small"
                                                                    startIcon={<HistoryIcon />}
                                                                    onClick={() => handleViewHistory(person)}
                                                                >
                                                                    Historique
                                                                </Button>
                                                            </Tooltip>
                                                        </div>
                                                    </TableCell>
                                                </TableRow>
                                            );
                                        })}
                                </TableBody>
                            </Table>
                            <TablePagination
                                rowsPerPageOptions={[5, 10, 25, 50]}
                                component="div"
                                count={filteredPersonnel.length}
                                rowsPerPage={rowsPerPage}
                                page={page}
                                onPageChange={handleChangePage}
                                onRowsPerPageChange={handleChangeRowsPerPage}
                                labelRowsPerPage="Lignes par page"
                            />
                        </>
                    )}
                </TableContainer>

                {/* Dialogue d'historique */}
                <ConsultationHistory
                    open={historyDialogOpen}
                    onClose={handleCloseHistoryDialog}
                    personId={selectedPersonnelForHistory?.user_id || selectedPersonnelForHistory?.person_id}
                    personName={selectedPersonnelForHistory?.full_name}
                />
            </div>
        </MainContainer>
    );
}